import React from 'react'

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string
}

const SvgIcon: React.FC<SvgIconProps> = ({ fill = 'currentColor', ...props }) => {
  return (
    <svg {...props} fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M7,0L0,7V17l7,7H17c2.4-2.3,7-7,7-7V7l-7-7 M8.1,2.7h7.7l5.5,5.5v7.7l-5.5,5.5H8.1l-5.5-5.5V8.1 M10.7,16h2.7v2.7h-2.7V16 M10.7,5.3h2.7v8h-2.7V5.3" />
    </svg>
  )
}

type ReportGmailerrorredIconProps = SvgIconProps

export const ReportGmailerrorredIcon: React.FC<ReportGmailerrorredIconProps> = (props) => {
  return <SvgIcon {...props} viewBox="0 0 24 24" focusable="false" aria-hidden="true" />
}
